import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class DocumentService {
  constructor(private http: HttpClient) { }

  getDocuments(personId: string, requestId: string, mdmId: string) {
    return this.http.get(`/api/getDocuments/${personId}/${requestId}/${mdmId}`, {
      responseType: "json"
    });
  }

  getInternalDocumentType() {
    return this.http.get(
      `/api/internaldocumenttype/documentTypes?verbose=true`
    );
  }

  getDocumentTypeById(documentTypeId: string) {
    return this.http.get(`/api/DocumentType/getDocumentTypeById`, {
      params: { type: documentTypeId },
      responseType: "json"
    });
  }

  getUplodedDocuments(personId: string, documentTypeId: string) {
    return this.http.get(`/api/PersonDocument/getPersonDocumentByDocTypeId`, {
      params: { PERSON_ID: personId, DOCUMENT_TYPE_ID: documentTypeId },
      responseType: "json"
    });
  }

  getInternalUplodedDocuments(personId: string, documentTypeId: string) {
    return this.http.get(
      `/api/InternalPersonDocument/getPersonDocumentByDocTypeId`,
      {
        params: { PERSON_ID: personId, DOCUMENT_TYPE_ID: documentTypeId },
        responseType: "json"
      }
    );
  }

  updateRequestForDocument(data: any) {
    return this.http.put(`/api/Request/updateRequestForDocument`, data, {
      observe: "response"
    });
  }

  updateInternalRequestForDocument(data: any) {
    return this.http.put(
      `/api/internalRequest/updateRequestForDocument`,
      data,
      {
        observe: "response"
      }
    );
  }

  downloadFile(decisionDocPayload: any) {
    return window.open(
      `/api/internals3decisiondoc/downloadDecisionDocument?file=${
      decisionDocPayload.fileName
      }&PERSON_ID=${decisionDocPayload.PERSON_ID}&REQUEST_ID=${
      decisionDocPayload.REQUEST_ID
      }&REVIEW_DETAIL_ID=${decisionDocPayload.REVIEW_DETAIL_ID}`
    );
  }
}



// WEBPACK FOOTER //
// ./client/views/services/document.service.ts